/* eslint-disable @typescript-eslint/no-explicit-any */
import { InjectionToken } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseDto } from '@ideapa/common-dto';
import { FilterValue } from '@ideapa/common-interfaces';
import { Observable } from 'rxjs';

export const ROUTER_SERVICE_TOKEN = new InjectionToken('RouterFacade');

export interface RouterFacadeInterface {
  notifySelectedItemToOpener(item: BaseDto, channelId: string): void;
  notifyDeletedItemToOpener(id: number, channelId: string): void;
  addNewEntity(
    entity: string,
    queryParams?: string,
    customTitle?: string
  ): Promise<any>;
  openEntityDetail(
    entity: string,
    id: number,
    edit: boolean,
    queryParams?: string,
    customTitle?: string
  ): Promise<any>;
  searchEntity(
    entity: string,
    filters?: FilterValue[],
    areDomainUserFiltersDisabled?: boolean,
    isEntitySelectionLimited?: boolean,
    areEnteAnnoFiltersDisabled?: boolean,
  ): Promise<any>;
  openEntityList<Tparam>(
    entity: string,
    param: Partial<Tparam>,
    filters?: FilterValue[],
    title?: string,
    fullscreen?: boolean
  ): Promise<void>;

  // isFindMode(): boolean;
  // isEditMode(): boolean;
  // isAddMode(): boolean;
  // isModalListMode(): boolean;
  // isViewOnlyMode(): boolean;

  isFindMode$: Observable<boolean>;
  isEditMode$: Observable<boolean>;
  isAddMode$: Observable<boolean>;
  isModalListMode$: Observable<boolean>;
  isViewOnlyMode$: Observable<boolean>;
  channelId$: Observable<string | undefined>;

  navigateRelative(
    commands: any[],
    replace?: boolean,
    relativeTo?: ActivatedRoute | null
  ): void;
  // readonly router: Router;
  // getCurrentRoute(): ActivatedRoute;
}
